export const initialState: any = {
  isLoggedIn: false,
  bankAccount: {},
  customerProfile: {},
}
